//
//
//
//
//
//

export default {
    beforeRouteEnter(to, form, next) {
        const url = to.query.src;
        next(vm => {
            vm.src = url;
        });
    },
    data() {
        return {
            src: ''
        };
    }
};
